<tran-ui-content-section [backgroundImage]="backgroundImage()" [showOverlay]="true">
    <div class="pt-20 pb-[104px]">
        <div class="flex flex-col p-10 gap-6 bg-deep-blue-850 rounded-lg">
            <h3 class="font-bold text-hero-xs-4">
                {{ titleKey() | translate }}
            </h3>
            <div class="flex flex-wrap gap-4">
                @for (link of links(); let index = $index; track index) {
                    <div class="py-2 pr-[22px]">
                        <tran-custom-text-link [label]="link.label" [url]="link.url" [ariaLabel]="link.ariaLabel" [blankTab]="link.isExternal" />
                    </div>
                }
            </div>
        </div>
    </div>
</tran-ui-content-section>
